import { Route } from '@angular/router';

import { RootPageComponent } from './layout/root-page.component';
import { viewContextGuard } from './navigation/view-context-guard';
import { Error404PageComponent } from './pages/global/404/error-404-page.component';
import { HomePageComponent } from './pages/global/home/home-page.component';
import { SignInPageComponent } from './pages/global/login/signin-page.component';
import { signInPageGuard } from './pages/global/login/signin-page.guard';
import { StoreSelectorPageComponent } from './pages/global/resource-selector/store-selector-page.component';
import { SubscriptionSelectorPageComponent } from './pages/global/resource-selector/subscription-selector-page.component';
import { SearchPageComponent } from './pages/global/search/search-page.component';
import { LibraryCachePageComponent } from './pages/library-management/cache/library-cache-page.component';
import { LibraryAuthorizedUserComponent } from './pages/library-management/permission/library-authorized-user.component';
import { LibrariesPageComponent } from './pages/library-management/update/libraries-page.component';
import { LibraryPageComponent } from './pages/library-management/update/library-page.component';
import { StoreCleanupConfigPageComponent } from './pages/store-management/cleanup-config/store-cleanup-config-page.component';
import { StoreDesignerAssetsComponent } from './pages/store-management/designer/store-designer-assets.component';
import { StoreDesignerCustomCssComponent } from './pages/store-management/designer/store-designer-custom-css.component';
import { StoreDesignerCustomJavascriptComponent } from './pages/store-management/designer/store-designer-custom-javascript.component';
import { StoreDesignerCustomLocalesComponentComponent } from './pages/store-management/designer/store-designer-custom-locales-component.component';
import { StoreDesignerLogoComponent } from './pages/store-management/designer/store-designer-logo.component';
import {
    StoreDesignerVersionConfigurationComponent as StoreDesignerReleaseChannelConfigurationComponent
} from './pages/store-management/designer/store-designer-release-channel-configuration.component';
import { StoreFilterCategoriesPageComponent } from './pages/store-management/filter/store-filter-categories-page.component';
import { StorePhotoFilterConfigurationsComponent } from './pages/store-management/filter/store-photo-filter-configurations.component';
import { StoreRemoteFilterPageComponent } from './pages/store-management/filter/store-remote-filter-page.component';
import { StoreFulfillerLogsPageComponent } from './pages/store-management/fulfiller/store-fulfiller-logs-page.component';
import { StoreFulfillerPageComponent } from './pages/store-management/fulfiller/store-fulfiller-page.component';
import { StoreFulfillersPageComponent } from './pages/store-management/fulfiller/store-fulfillers-page.component';
import { GeneratedImagePageComponent } from './pages/store-management/generated-image/generated-image-page.component';
import { GeneratedImageStoreAssociationPageComponent } from './pages/store-management/generated-image/generated-image-store-association-page.component';
import { GeneratedImageStoreAssociationsPageComponent } from './pages/store-management/generated-image/generated-image-store-associations-page.component';
import { GeneratedImagesPageComponent } from './pages/store-management/generated-image/generated-images-page.component';
import { StoreGeneratedTextPageComponent } from './pages/store-management/generated-text/store-generated-text-page.component';
import { StoreLibrarySettingsPageComponent } from './pages/store-management/library-settings/store-library-settings-page.component';
import { StoreLogsPageComponent } from './pages/store-management/log/store-logs-page.component';
import { StoreStatusPageComponent } from './pages/store-management/mediaclip-managment/store-status-page.component';
import { StoreAuthorizedUsersPageComponent } from './pages/store-management/permission/store-authorized-users-page.component';
import { BuiltInExternalPhotoSourceEditPageComponent } from './pages/store-management/photo-source/built-in-external-photo-source-edit-page.component';
import { DirectPhotoSourceEditPageComponent } from './pages/store-management/photo-source/direct-photo-source-edit-page.component';
import { ExternalPhotoSourcesPageComponent } from './pages/store-management/photo-source/external-photo-sources-page.component';
import { GenericExternalPhotoSourceEditPageComponent } from './pages/store-management/photo-source/generic-external-photo-source-edit-page.component';
import { SessionPhotoSourceEditPageComponent } from './pages/store-management/photo-source/session-photo-source-edit-page.component';
import { StoreSecretsPageComponent } from './pages/store-management/secret/store-secrets-page.component';
import { StoreEndpointsPageComponent } from './pages/store-management/setting/store-endpoints-page.component';
import { StoreSettingsPageComponent } from './pages/store-management/setting/store-settings-page.component';
import { StorePhotosUpscalingPageComponent } from './pages/store-management/upscaling/store-photos-upscaling-page.component';
import { DashboardsOverviewPageComponent } from './pages/store-support/dashboard/dashboards-overview-page.component';
import { AnomaliesPageComponent } from './pages/store-support/order/anomalies-page.component';
import { CreateOrderComponent } from './pages/store-support/order/create-order.component';
import { OrderPageComponent } from './pages/store-support/order/order-page.component';
import { OrdersPageComponent } from './pages/store-support/order/orders-page.component';
import { PhotoPageComponent } from './pages/store-support/photo/photo-page.component';
import { ProductPageComponent } from './pages/store-support/product/product-page.component';
import { ProductsPageComponent } from './pages/store-support/product/products-page.component';
import { MediaclipDesignerComponent } from './pages/store-support/project/mediaclip-designer.component';
import { ProjectPageComponent } from './pages/store-support/project/project-page.component';
import { SharedProjectPageComponent } from './pages/store-support/project/shared-project-page.component';
import { UserPageComponent } from './pages/store-support/user/user-page.component';
import { StoreWebhookLogsPageComponent } from './pages/store-support/webhook-logs/store-webhook-logs-page.component';
import { SubscriptionBillingPageComponent } from './pages/subscription-management/billing/subscription-billing-page.component';
import { SubscriptionAuthorizedUserPageComponent } from './pages/subscription-management/permission/subscription-authorized-user-page.component';
import { PowerBiReportPageComponent } from './pages/subscription-management/powerbi/power-bi-report-page.component';
import { SubscriptionCleanupConfigPageComponent } from './pages/subscription-management/settings/subscription-cleanup-config-page.component';
import { SubscriptionPageComponent } from './pages/subscription-management/settings/subscription-page.component';
import { ManageDesignerReleaseChannelVersionPageComponent } from './pages/superadmin/designer-channel/manage-designer-release-channel-version.component';
import { FulfillerAuthorizedUserComponent } from './pages/superadmin/fulfiller/fulfiller-authorized-user.component';
import { FulfillerPageComponent } from './pages/superadmin/fulfiller/fulfiller-page.component';
import { FulfillerSecretsPageComponent } from './pages/superadmin/fulfiller/fulfiller-secrets-page.component';
import { FulfillersPageComponent } from './pages/superadmin/fulfiller/fulfillers-page.component';
import { GraphExplorerPageComponent } from './pages/superadmin/graph-exporer/graph-explorer-page.component';
import { RequestLoggerPageComponent } from './pages/superadmin/request-logger/request-logger-page.component';
import { StockPhotoSourcePageComponent } from './pages/superadmin/stock-photo/stock-photo-source-page.component';
import { StockPhotoSourcesPageComponent } from './pages/superadmin/stock-photo/stock-photo-sources-page.component';
import { SubscriptionsPageComponent } from './pages/superadmin/subscription/subscriptions-page.component';
import { AdminUserPageComponent } from './pages/superadmin/user/admin-user-page.component';
import { AdminUsersPageComponent } from './pages/superadmin/user/admin-users-page.component';

export const routes: Route[] = [
    {
        path: '',
        component: RootPageComponent
    },
    {
        path: 'signin-auth0',
        canActivate: [signInPageGuard],
        component: SignInPageComponent
    },
    {
        path: 'home',
        component: HomePageComponent
    },
    {
        path: 'search',
        component: SearchPageComponent
    },
    {
        path: 'orders/:orderId',
        component: OrderPageComponent
    },
    {
        path: 'projects/:projectId',
        component: ProjectPageComponent
    },
    {
        path: 'shared-projects/:sharedProjectId',
        component: SharedProjectPageComponent
    },
    {
        path: 'projects/:projectId/edit',
        component: MediaclipDesignerComponent
    },
    {
        path: 'projects/:projectId/versions/:projectVersionId',
        component: ProjectPageComponent
    },
    {
        path: 'users/:userId',
        component: UserPageComponent
    },
    {
        path: 'users/:hubUserId/photos/:photoUrn',
        component: PhotoPageComponent
    },
    {
        path: 'select-store',
        component: StoreSelectorPageComponent
    },
    {
        path: 'select-subscription',
        component: SubscriptionSelectorPageComponent
    },
    {
        path: 'stores/:storeId',
        canActivate: [viewContextGuard],
        children: [
            {
                path: 'dashboards/overview',
                component: DashboardsOverviewPageComponent
            },
            {
                path: 'logs/fulfillers/:fulfillerId',
                component: StoreFulfillerLogsPageComponent
            },
            {
                path: 'logs',
                component: StoreLogsPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/logs'
                }
            },
            {
                path: 'webhook-logs',
                component: StoreWebhookLogsPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/webhook-logs'
                }
            },
            {
                path: 'lists/action-required',
                component: OrdersPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/lists/action-required',
                    ordersView: 'actionRequired'
                }
            },
            {
                path: 'lists/recent',
                component: OrdersPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/lists/recent',
                    ordersView: 'recent'
                }
            },
            {
                path: 'create-order',
                component: CreateOrderComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/create-order'
                }
            },
            {
                path: 'orders/:storeOrderId',
                children: [
                    {
                        path: '',
                        component: OrderPageComponent
                    },
                    {
                        path: 'lines/:storeLineNumber/edit',
                        component: MediaclipDesignerComponent
                    },
                    {
                        path: 'lines/:storeLineNumber',
                        component: OrderPageComponent
                    }
                ]
            },
            {
                path: 'library/products',
                component: ProductsPageComponent
            },
            {
                path: 'library/product',
                component: ProductPageComponent
            },
            {
                path: 'settings/endpoints',
                component: StoreEndpointsPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/endpoints'
                }
            },
            {
                path: 'settings/general',
                component: StoreSettingsPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/general'
                }
            },
            {
                path: 'settings/library',
                component: StoreLibrarySettingsPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/library'
                }
            },
            {
                path: 'settings/cleanup',
                component: StoreCleanupConfigPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/cleanup'
                }
            },
            {
                path: 'settings/status',
                component: StoreStatusPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/status'
                }
            },
            {
                path: 'settings/external-photo-sources',
                component: ExternalPhotoSourcesPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/external-photo-sources'
                }
            },
            {
                path: 'settings/photos-upscaling',
                component: StorePhotosUpscalingPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/photos-upscaling'
                }
            },
            {
                path: 'settings/generated-text',
                component: StoreGeneratedTextPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/generated-text'
                }
            },
            {
                path: 'settings/external-photo-sources/generic/create/:photoSourceId',
                component: GenericExternalPhotoSourceEditPageComponent,
                data: {
                    mode: 'create',
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/external-photo-sources'
                }
            },
            {
                path: 'settings/external-photo-sources/generic/edit/:photoSourceId',
                component: GenericExternalPhotoSourceEditPageComponent,
                data: {
                    mode: 'edit',
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/external-photo-sources'
                }
            },
            {
                path: 'settings/external-photo-sources/direct/create/:photoSourceId',
                component: DirectPhotoSourceEditPageComponent,
                data: {
                    mode: 'create',
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/external-photo-sources'
                }
            },
            {
                path: 'settings/external-photo-sources/direct/edit/:photoSourceId',
                component: DirectPhotoSourceEditPageComponent,
                data: {
                    mode: 'edit',
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/external-photo-sources'
                }
            },
            {
                path: 'settings/external-photo-sources/built-in/create/:photoSourceId',
                component: BuiltInExternalPhotoSourceEditPageComponent,
                data: {
                    mode: 'create',
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/external-photo-sources'
                }
            },
            {
                path: 'settings/external-photo-sources/built-in/edit/:photoSourceId',
                component: BuiltInExternalPhotoSourceEditPageComponent,
                data: {
                    mode: 'edit',
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/external-photo-sources'
                }
            },
            {
                path: 'settings/external-photo-sources/session/create/:photoSourceId',
                component: SessionPhotoSourceEditPageComponent,
                data: {
                    mode: 'create',
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/external-photo-sources'
                }
            },
            {
                path: 'settings/external-photo-sources/session/edit/:photoSourceId',
                component: SessionPhotoSourceEditPageComponent,
                data: {
                    mode: 'edit',
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/external-photo-sources'
                }
            },
            {
                path: 'designer/release-channel',
                component: StoreDesignerReleaseChannelConfigurationComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/designer/release-channel'
                }
            },
            {
                path: 'designer/generated-images',
                children: [
                    {
                        path: '',
                        component: GeneratedImageStoreAssociationsPageComponent,
                        data: {
                            viewContextType: 'store',
                            viewContextChangeUrl: 'stores/:storeId/designer/generated-images'
                        }
                    },
                    {
                        path: 'create',
                        component: GeneratedImageStoreAssociationPageComponent,
                        data: {
                            viewContextType: 'store',
                            viewContextChangeUrl: 'stores/:storeId/designer/generated-images/create'
                        }
                    },
                    {
                        path: ':associationId',
                        component: GeneratedImageStoreAssociationPageComponent,
                        data: {
                            viewContextType: 'store',
                            viewContextChangeUrl: 'stores/:storeId/designer/generated-images'
                        }
                    }
                ]
            },
            {
                path: 'designer/assets',
                component: StoreDesignerAssetsComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/designer/assets'
                }
            },
            {
                path: 'designer/custom-javascript',
                component: StoreDesignerCustomJavascriptComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/designer/custom-javascript'
                }
            },
            {
                path: 'designer/custom-locales',
                component: StoreDesignerCustomLocalesComponentComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/designer/custom-locales'
                }
            },
            {
                path: 'designer/custom-css',
                component: StoreDesignerCustomCssComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/designer/custom-css'
                }
            },
            {
                path: 'designer/logo',
                component: StoreDesignerLogoComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/designer/logo'
                }
            },
            {
                path: 'designer/photo-filters',
                component: StorePhotoFilterConfigurationsComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/designer/photo-filters'
                }
            },
            {
                path: 'designer/remote-filters',
                component: StoreRemoteFilterPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/designer/remote-filters'
                }
            },
            {
                path: 'designer/filter-categories',
                component: StoreFilterCategoriesPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/designer/filter-categories'
                }
            },
            {
                path: 'settings/authorized-users',
                component: StoreAuthorizedUsersPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/authorized-users'
                }
            },
            {
                path: 'settings/fulfillers',
                component: StoreFulfillersPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/fulfillers'
                }
            },
            {
                path: 'settings/fulfillers/:fulfillerId',
                component: StoreFulfillerPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/fulfillers'
                }
            },
            {
                path: 'settings/secrets',
                component: StoreSecretsPageComponent,
                data: {
                    viewContextType: 'store',
                    viewContextChangeUrl: 'stores/:storeId/settings/secrets'
                }
            }
        ]
    },
    {
        path: 'anomalies',
        component: AnomaliesPageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'manage-designer-release-channel-version',
        component: ManageDesignerReleaseChannelVersionPageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'subscriptions',
        component: SubscriptionsPageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'subscriptions/:subscriptionId',
        canActivate: [viewContextGuard],
        children: [
            {
                path: '',
                component: SubscriptionPageComponent,
                data: {
                    viewContextType: 'subscription',
                    viewContextChangeUrl: 'subscriptions/:subscriptionId'
                }
            },
            {
                path: 'authorizedUsers',
                component: SubscriptionAuthorizedUserPageComponent,
                data: {
                    viewContextType: 'subscription',
                    viewContextChangeUrl: 'subscriptions/:subscriptionId/authorizedUsers'
                }
            },
            {
                path: 'billing',
                component: SubscriptionBillingPageComponent,
                data: {
                    viewContextType: 'subscription',
                    viewContextChangeUrl: 'subscriptions/:subscriptionId/billing'
                }
            },
            {
                path: 'cleanup',
                component: SubscriptionCleanupConfigPageComponent,
                data: {
                    viewContextType: 'subscription',
                    viewContextChangeUrl: 'subscriptions/:subscriptionId/cleanup'
                }
            },
            {
                path: 'generated-images',
                component: GeneratedImagesPageComponent,
                data: {
                    viewContextType: 'subscription',
                    viewContextChangeUrl: 'subscriptions/:subscriptionId/generated-images'
                }
            },
            {
                path: 'generated-images/create',
                component: GeneratedImagePageComponent,
                data: {
                    viewContextType: 'subscription',
                    viewContextChangeUrl: 'subscriptions/:subscriptionId/generated-images'
                }
            },
            {
                path: 'generated-images/:generatedImageId',
                component: GeneratedImagePageComponent,
                data: {
                    viewContextType: 'subscription',
                    viewContextChangeUrl: 'subscriptions/:subscriptionId/generated-images/:generatedImageId'
                }
            },
            {
                path: 'power-bi-report',
                component: PowerBiReportPageComponent,
                data: {
                    viewContextType: 'subscription',
                    viewContextChangeUrl: 'subscriptions/:subscriptionId/power-bi-report'
                }
            }
        ]
    },
    {
        path: 'fulfillers',
        component: FulfillersPageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'libraries',
        component: LibrariesPageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'library-cache',
        component: LibraryCachePageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'graph-explorer',
        component: GraphExplorerPageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'libraries/:libraryOwner',
        canActivate: [viewContextGuard],
        component: LibraryPageComponent,
        data: {
            viewContextType: 'library',
            viewContextChangeUrl: 'libraries/:libraryOwner'
        }
    },
    {
        path: 'libraries/:libraryOwner/authorizedUsers',
        canActivate: [viewContextGuard],
        component: LibraryAuthorizedUserComponent,
        data: {
            viewContextType: 'library',
            viewContextChangeUrl: 'libraries/:libraryOwner/authorizedUsers'
        }
    },
    {
        path: 'photos/:photoUrn',
        component: PhotoPageComponent
    },
    {
        path: 'fulfillers/:fulfillerId',
        canActivate: [viewContextGuard],
        component: FulfillerPageComponent
    },
    {
        path: 'fulfillers/:fulfillerId/authorizedUsers',
        canActivate: [viewContextGuard],
        component: FulfillerAuthorizedUserComponent,
        data: {
            viewContextType: 'fulfiller',
            viewContextChangeUrl: 'fulfillers/:fulfillerId/authorizedUsers'
        }
    },
    {
        path: 'fulfillers/:fulfillerId/secrets',
        canActivate: [viewContextGuard],
        component: FulfillerSecretsPageComponent,
        data: {
            viewContextType: 'fulfiller',
            viewContextChangeUrl: 'fulfillers/:fulfillerId/secrets'
        }
    },
    {
        path: 'stock-photo-sources',
        component: StockPhotoSourcesPageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'request-logger',
        component: RequestLoggerPageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'stock-photo-sources/:stockPhotoSourceId',
        component: StockPhotoSourcePageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'generated-images',
        component: GeneratedImagesPageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'generated-images/create',
        component: GeneratedImagePageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'generated-images/:generatedImageId',
        component: GeneratedImagePageComponent,
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: 'admin-users',
        children: [
            {
                path: '',
                component: AdminUsersPageComponent
            },
            {
                path: ':userEmail',
                component: AdminUserPageComponent
            }
        ],
        data: {
            viewContextType: 'global'
        }
    },
    {
        path: '**',
        component: Error404PageComponent,
        data: {
            viewContextType: 'global'
        }
    }
];
